export default __webpack_public_path__ + "static/media/logout.13336007.svg";